<div class="flex flex-wrap mt-8 mb-6">
    @let myRole = myRoles$ | async;

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
        @if(group?.academicYear == gradeLesson?.academicYear) {
        <app-btn-action label="Publish" [inProgress]="(loading$ | async) ?? false"
            [isDisabled]="!(myRole.management || (myRole.faculty && group?.gradeId == gradeLesson?.gradeId))"
            (clicked)="onPublish()" icon="fa fa-upload"></app-btn-action>
        }
    </div>

    <div class="flex flex-row justify-between mb-4 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">
            {{ note?.name || (gradeLesson?.lessonName + ' Notes') }}
        </h1>
    </div>

    <div class="rounded-t block w-full overflow-x-auto overflow-y-auto shadow-lg rounded bg-white">
        @if(note?.url) {
        <rich-text-editor [jsonFormat]="htmlData" (contentChanged)="onContentChanged($event)"
            [isEditable]="group?.academicYear == gradeLesson?.academicYear && (myRole.management || (myRole.faculty && group?.gradeId == gradeLesson?.gradeId))"
            class="w-full"></rich-text-editor>
        } @else {
        <p class="text-gray-500 p-4">
            Note Content not found
        </p>
        }
    </div>